(function () {
  'use strict';

  var COLOR_OPTION_NAME = 'Color';

  var SELECTORS = {
    productCard:  '.card-wrapper',
    productImage: '.card__media img, .card__media .motion-reduce',
    productLink:  'a.card__heading, a.full-unstyled-link',
    productPrice: '.price__regular .price-item--regular',
    badge:        '.card__badge .badge'
  };

  var KNOWN_COLORS = [
    'red','green','blue','black','white','yellow','orange',
    'purple','pink','clear','natural','brown','gold','silver',
    'teal','navy','grey','gray','kraft'
  ];

  function getColorFromHandle(handle) {
    if (!handle) return null;
    var parts = handle.toLowerCase().split('-');
    for (var i = 0; i < parts.length; i++) {
      if (KNOWN_COLORS.indexOf(parts[i]) !== -1) return parts[i];
    }
    return null;
  }

  function findMatchingVariant(variants, color) {
    if (!variants || !color) return null;
    var c = color.toLowerCase();
    var matches = [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = [v.option1, v.option2, v.option3];
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] && opts[j].toLowerCase() === c) {
          matches.push(v);
          break;
        }
      }
    }
    if (!matches.length) return null;
    for (var k = 0; k < matches.length; k++) {
      if (matches[k].available) return matches[k];
    }
    return matches[0];
  }

  function swapCard(card, variant) {
    var links = card.querySelectorAll(SELECTORS.productLink);
    for (var i = 0; i < links.length; i++) {
      try {
        var base = links[i].href.split('?')[0];
        links[i].href = base + '?variant=' + variant.id;
      } catch(e) {}
    }

    if (variant.featured_image) {
      var img = card.querySelector(SELECTORS.productImage);
      if (img) {
        var src = variant.featured_image.src;
        img.src = src;
        if (img.dataset.src) img.dataset.src = src;
        if (img.dataset.srcset) img.dataset.srcset = src;
        img.srcset = '';
        img.alt = variant.featured_image.alt || img.alt;
      }
    }

    var priceEl = card.querySelector(SELECTORS.productPrice);
    if (priceEl && variant.price != null) {
      priceEl.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: 'USD'
      }).format(variant.price / 100);
    }

    if (!variant.available) {
      var badge = card.querySelector(SELECTORS.badge);
      if (badge) {
        badge.textContent = 'Sold out';
        badge.classList.add('badge--sold-out');
      }
    }
  }

  function init() {
    var handle = window.__collectionHandle;
    if (!handle) return;
    var color = getColorFromHandle(handle);
    if (!color) return;
    var cards = document.querySelectorAll(SELECTORS.productCard);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var raw = card.dataset.variants;
      if (!raw) continue;
      try {
        var variants = JSON.parse(raw);
        var match = findMatchingVariant(variants, color);
        if (match) swapCard(card, match);
      } catch(e) {
        console.warn('collection-variant-switcher: parse error on card', e);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
